import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import {
  Redirect,
  useParams,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import uploadIcon from "../resources/images/upload-icon.png";
import MdlSelectSession from "../dialog/MdlSelectSession";

const MarkEntryCheckList = () => {
  const { document_type } = useParams();

  // Memoize token check to avoid reading localStorage on every render
  const [loggedIn] = useState(() => {
    const token = localStorage.getItem("token");
    return token != null;
  });
  const [Loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE, setDOCUMENT_TYPE] = useState("");
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [CLASS_SECTION_NAME, setCLASS_SECTION_NAME] = useState("");

  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [mExamList, setMExamList] = useState([]);
  const [CLASS_ID, setCLASS_ID] = useState("");
  const [SECTION_ID, setSECTION_ID] = useState("");
  const [EXAM_ID, setEXAM_ID] = useState("");
  const [EXAM_NAME, setEXAM_NAME] = useState("");
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [SESSION_STATUS, setSESSION_STATUS] = useState("");
  const [EXAM_SELECTED_POSITION, setEXAM_SELECTED_POSITION] = useState(0);
  const [mClassList, setMClassList] = useState([]);
  const [selectedClassIndex, setSelectedClassIndex] = useState(-1);
  const [SUJECT_SELECTED_POSITION, setSUJECT_SELECTED_POSITION] = useState(-1);
  const [mSubject, setMSubject] = useState([]);
  const [selected_subject_id, setSelected_subject_id] = useState("");
  const [selected_subject_name, setSelected_subject_name] = useState("");
  const [iFrameHeight, setIFrameHeight] = useState("0px");
  // Refs to break circular dependencies
  const selectClassRef = useRef(null);
  const getSubjectRef = useRef(null);
  const getPrintableSamplesRef = useRef(null);
  const setFileUrLRef = useRef(null);
  const iframeRef = useRef(null);

  // Memoized style objects to prevent recreation on every render
  const commonButtonBaseStyle = useMemo(() => ({
    padding: "10px 20px",
    fontSize: "13px",
    fontWeight: "600",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    minWidth: "120px",
    minHeight: "42px",
    whiteSpace: "nowrap",
  }), []);

  const getButtonStyle = useCallback((isSelected) => ({
    ...commonButtonBaseStyle,
    border: `2px solid ${isSelected ? COLORS.primary_color_shade5 : COLORS.grey3}`,
    background: isSelected
      ? `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`
      : COLORS.white,
    color: isSelected ? COLORS.white : COLORS.primary_color_shade7,
    boxShadow: isSelected
      ? "0 4px 12px rgba(102, 126, 234, 0.35)"
      : "0 2px 6px rgba(0, 0, 0, 0.1)",
    transform: isSelected ? "translateY(-2px)" : "translateY(0)",
  }), [commonButtonBaseStyle]);

  const handleButtonMouseEnter = useCallback((e, isSelected) => {
    if (!isSelected) {
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.25)";
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.borderColor = COLORS.primary_color_shade5;
    }
  }, []);

  const handleButtonMouseLeave = useCallback((e, isSelected) => {
    if (!isSelected) {
      e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)";
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.borderColor = COLORS.grey3;
    }
  }, []);

  // Memoized empty/loading state styles
  const emptyStateStyle = useMemo(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "500px",
    background: COLORS.grey1,
    gap: "12px",
  }), []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setIFrameHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Initialize session and document type
  useEffect(() => {
    window.scrollTo(0, 0);
    setDOCUMENT_TYPE(document_type);
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession[0]) {
      setSESSION_ID(mSession[0].session_id);
      setSESSION_NAME(mSession[0].session_name);
      setSESSION_STATUS(mSession[0].status);
    }
  }, [document_type]);

  // Fetch exam list when session is available
  const getExamList = useCallback(() => {
    if (!SESSION_ID) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getExamListLite.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      session_id: SESSION_ID,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const exams = response.data || [];
          setMExamList(exams);
          if (exams.length > 0) {
            const first = exams[0];
            setEXAM_ID(first.exam_id);
            setEXAM_NAME(first.exam_name);
            setEXAM_SELECTED_POSITION(0);
          }
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching exam list:", error);
      });
  }, [SESSION_ID]);

  useEffect(() => {
    if (SESSION_ID) {
      getExamList();
    }
  }, [SESSION_ID, getExamList]);

  // Fetch classes and subjects when exam changes
  const getClassWithSubjectsPartAndPaper = useCallback((examIdParam) => {
    if (!SESSION_ID || !examIdParam) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getClassWithSubjectsPartAndPaper.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      exam_id: examIdParam,
      session_id: SESSION_ID,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const classList = response.data || [];
          setMClassList(classList);
          if (Array.isArray(classList) && classList.length > 0) {
            if (selectClassRef.current) {
              selectClassRef.current(0);
            }
          }
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching classes:", error);
      });
  }, [SESSION_ID]);

  // Auto-fetch classes when exam ID changes
  useEffect(() => {
    if (EXAM_ID && SESSION_ID) {
      getClassWithSubjectsPartAndPaper(EXAM_ID);
    }
  }, [EXAM_ID, SESSION_ID, getClassWithSubjectsPartAndPaper]);

  // Session dialog handlers
  const ChangeSession = useCallback(() => {
    setIsOpenSessionDialog(true);
  }, []);

  const HandleCloseSessionDialog = useCallback(() => {
    setIsOpenSessionDialog(false);
  }, []);

  const HandleSelectedSession = useCallback((session_id, session_name, session_status) => {
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    setSESSION_STATUS(session_status);
    setIsOpenSessionDialog(false);
  }, []);

  // Exam selection handler - batch state updates
  const SelectExam = useCallback((exam_id, exam_name, position) => {
    // Batch state updates to prevent multiple re-renders
    setEXAM_ID(exam_id);
    setEXAM_NAME(exam_name);
    setEXAM_SELECTED_POSITION(position);
    // Reset file info and samples when exam changes
    setFILE_NAME("");
    setFILE_DIRECTORY("");
    setSELECTED_SAMPLE_ID("");
    setMPrintableSamples([]);
    setFILE_URL("");
  }, []);

  // Class selection handler - batch state updates
  const selectClass = useCallback((position) => {
    if (position >= 0 && mClassList[position]) {
      const selectedClass = mClassList[position];
      const normalizedSectionId =
        selectedClass.section_id === "null" ? "No" : selectedClass.section_id;
      const classSectionName = normalizedSectionId === "No"
        ? selectedClass.class_name
        : `${selectedClass.class_name}:${selectedClass.section_name}`;
      
      // Batch state updates
      setCLASS_ID(selectedClass.class_id);
      setSECTION_ID(normalizedSectionId);
      setSelectedClassIndex(position);
      setCLASS_SECTION_NAME(classSectionName);
      // Reset subject selection when class changes
      setSUJECT_SELECTED_POSITION(-1);
      setSelected_subject_id("");
      setSelected_subject_name("");
      if (getSubjectRef.current) {
        getSubjectRef.current(-1, position);
      }
    }
  }, [mClassList]);
  
  selectClassRef.current = selectClass;

  // Subject selection handler
  const getSubject = useCallback((selected_position_subject, classIndex) => {
    const index = classIndex ?? selectedClassIndex;
    const subjects = (mClassList[index] && mClassList[index].subject) || [];
    setMSubject(subjects || []);
    
    if (selected_position_subject >= 0) {
      if (subjects && subjects.length > 0 && selected_position_subject < subjects.length) {
        const selectedSubject = subjects[selected_position_subject];
        setSUJECT_SELECTED_POSITION(selected_position_subject);
        setSelected_subject_id(selectedSubject.subject_id);
        setSelected_subject_name(selectedSubject.subject_name);
        
        if (!mPrintableSamples || mPrintableSamples.length === 0) {
          if (getPrintableSamplesRef.current) {
            getPrintableSamplesRef.current(selectedSubject.subject_id, selectedSubject.subject_name);
          }
        } else {
          if (setFileUrLRef.current) {
            setFileUrLRef.current(selectedSubject.subject_id, selectedSubject.subject_name);
          }
        }
      } else {
        setSUJECT_SELECTED_POSITION(-1);
        setSelected_subject_id("");
        setSelected_subject_name("");
        setMSubject([]);
      }
    } else {
      setSUJECT_SELECTED_POSITION(-1);
      setMSubject([...subjects]);
    }
  }, [selectedClassIndex, mClassList, mPrintableSamples]);
  
  getSubjectRef.current = getSubject;

  // Fetch printable samples
  const getPrintableSamples = useCallback((pendingSubjectId = null, pendingSubjectName = null) => {
    if (!DOCUMENT_TYPE) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: DOCUMENT_TYPE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const samples = response.data || [];
          setMPrintableSamples(samples);
          // Pass subject info and current exam values to setSample
          if (setSampleRef.current) {
            setSampleRef.current(samples, pendingSubjectId, pendingSubjectName);
          }
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching printable samples:", error);
      });
  }, [DOCUMENT_TYPE]);
  
  getPrintableSamplesRef.current = getPrintableSamples;

  // Internal function to build URL with all required parameters
  const setFileUrLWithValues = useCallback((
    fileName,
    fileDirectory,
    sampleId,
    subjectId,
    subjectName,
    examId,
    examName
  ) => {
    if (!fileDirectory || !fileName) {
      return;
    }
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    
    // Build URL with all parameters using URLSearchParams for cleaner code
    const baseUrl = process.env.REACT_APP_SERVER_NAME + fileDirectory + fileName;
    const params = new URLSearchParams({
      class_id: CLASS_ID || "",
      section_id: SECTION_ID || "",
      class_section_name: CLASS_SECTION_NAME || "",
      session_id: SESSION_ID || "",
      exam_id: examId || "",
      exam_name: examName || "",
      subject_id: subjectId || "",
      subject_name: subjectName || "",
      sample_id: sampleId || "",
      system_code: process.env.REACT_APP_SYSTEM_CODE || "",
      school_code: SCHOOL_CODE || "",
    });
    
    const url = `${baseUrl}?${params.toString()}`;
    
    if (process.env.NODE_ENV === 'development') {
      console.log("FILE_URL", url);
    }
    setFILE_URL(url);
  }, [CLASS_ID, SECTION_ID, CLASS_SECTION_NAME, SESSION_ID]);

  // Set sample and generate URL
  const setSampleRef = useRef(null);
  const setSample = useCallback((samples, pendingSubjectId = null, pendingSubjectName = null) => {
    const list = samples || mPrintableSamples;
    if (!list || list.length === 0) return;
    
    const first = list[0];
    const fileName = first.file_name || '';
    const fileDirectory = first.file_directory || '';
    const sampleId = first.sample_id || '';
    
    // Update state
    setFILE_NAME(fileName);
    setFILE_DIRECTORY(fileDirectory);
    setSELECTED_SAMPLE_POSITION(0);
    setSELECTED_SAMPLE_ID(sampleId);
    
    // Use pending subject info if provided, otherwise use state values
    const subjectIdToUse = pendingSubjectId !== null ? pendingSubjectId : selected_subject_id;
    const subjectNameToUse = pendingSubjectName !== null ? pendingSubjectName : selected_subject_name;
    
    // Get current exam values from state at call time
    setFileUrLWithValues(
      fileName,
      fileDirectory,
      sampleId,
      subjectIdToUse,
      subjectNameToUse,
      EXAM_ID,
      EXAM_NAME
    );
  }, [mPrintableSamples, selected_subject_id, selected_subject_name, EXAM_ID, EXAM_NAME, setFileUrLWithValues]);
  
  setSampleRef.current = setSample;

  // Public function to set file URL with subject parameters
  const setFileUrL = useCallback((subjectIdParam = null, subjectNameParam = null) => {
    if (!FILE_DIRECTORY || !FILE_NAME) {
      return;
    }
    
    // Use passed parameters if provided, otherwise use state values
    const subjectId = subjectIdParam !== null ? subjectIdParam : selected_subject_id;
    const subjectName = subjectNameParam !== null ? subjectNameParam : selected_subject_name;
    
    // Always use current exam values from state
    setFileUrLWithValues(
      FILE_NAME,
      FILE_DIRECTORY,
      SELECTED_SAMPLE_ID,
      subjectId,
      subjectName,
      EXAM_ID,
      EXAM_NAME
    );
  }, [FILE_DIRECTORY, FILE_NAME, SELECTED_SAMPLE_ID, selected_subject_id, selected_subject_name, EXAM_ID, EXAM_NAME, setFileUrLWithValues]);
  
  setFileUrLRef.current = setFileUrL;

  // Iframe handlers
  const handleIframeLoad = useCallback(() => {
    setShowPreview(false);
  }, []);

  const handleIframeError = useCallback(() => {
    setShowPreview(false);
    if (process.env.NODE_ENV === 'development') {
      console.error("Failed to load iframe:", FILE_URL);
    }
  }, [FILE_URL]);

  // Show loading state when URL changes - memoized to prevent unnecessary re-renders
  useEffect(() => {
    if (FILE_URL) {
      setShowPreview(true);
      const timeout = setTimeout(() => {
        setShowPreview(false);
      }, 2000);
      return () => clearTimeout(timeout);
    } else {
      setShowPreview(false);
    }
  }, [FILE_URL]);

  // Memoize session header style to prevent recreation
  const sessionHeaderStyle = useMemo(() => ({
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
    borderRadius: "8px",
    padding: "10px 14px",
    marginBottom: "8px",
    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.2)",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  }), []);

  // Memoize session header handlers
  const handleSessionHeaderMouseEnter = useCallback((e) => {
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.3)";
  }, []);

  const handleSessionHeaderMouseLeave = useCallback((e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 2px 8px rgba(102, 126, 234, 0.2)";
  }, []);

  // Memoize common container styles
  const containerCardStyle = useMemo(() => ({
    background: COLORS.white,
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: `1px solid ${COLORS.grey3}`,
  }), []);

  const classSubjectCardStyle = useMemo(() => ({
    background: COLORS.white,
    borderRadius: "8px",
    padding: "14px",
    marginBottom: "8px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
    border: `1px solid ${COLORS.grey3}`,
  }), []);

  const previewCardStyle = useMemo(() => ({
    background: COLORS.white,
    borderRadius: "8px",
    padding: "14px",
    marginTop: "8px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
    border: `1px solid ${COLORS.grey3}`,
  }), []);

  if (loggedIn === false) {
    return <Redirect to="/Login" />;
  }
  
  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#">Mark Entry Check List </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="animated fadeInUpn bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "30px", padding: "12px" }}
      >
        {/* Session Header */}
        <div
          style={sessionHeaderStyle}
          onClick={ChangeSession}
          onMouseEnter={handleSessionHeaderMouseEnter}
          onMouseLeave={handleSessionHeaderMouseLeave}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="fa fa-calendar" style={{ fontSize: "16px", color: COLORS.white }} />
              <div>
                <div style={{ fontSize: "10px", color: "rgba(255, 255, 255, 0.9)", fontWeight: "500" }}>
                  Current Session
                </div>
                <div style={{ fontSize: "14px", color: COLORS.white, fontWeight: "600" }}>
                  {SESSION_NAME} ({SESSION_STATUS})
                </div>
              </div>
            </div>
            <img
              src={uploadIcon}
              alt="change session"
              style={{ height: "22px", width: "22px", opacity: 0.9 }}
            />
          </div>
        </div>

        {isOpenSessionDialog && (
          <MdlSelectSession
            action={HandleCloseSessionDialog}
            action2={HandleSelectedSession}
          />
        )}

        {/* Exam Selection */}
        <div style={containerCardStyle}>
          <h6 style={{ 
            margin: "0 0 12px 0", 
            fontSize: "13px", 
            fontWeight: "700", 
            color: COLORS.primary_color_shade7,
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <i className="fa fa-file-text" style={{ fontSize: "15px", color: COLORS.primary_color_shade5 }} />
            Select Exam
          </h6>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {mExamList.map((item, index) => {
              const isSelected = EXAM_SELECTED_POSITION === index;
              return (
                <button
                  key={`exam-${item.exam_id}-${index}`}
                  onClick={() => SelectExam(item.exam_id, item.exam_name, index)}
                  style={{
                    padding: "10px 18px",
                    fontSize: "13px",
                    fontWeight: "600",
                    borderRadius: "8px",
                    border: `2px solid ${isSelected ? COLORS.primary_color_shade5 : COLORS.grey3}`,
                    background: isSelected
                      ? `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`
                      : `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey1} 100%)`,
                    color: isSelected ? COLORS.white : COLORS.primary_color_shade7,
                    cursor: "pointer",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: isSelected
                      ? "0 4px 12px rgba(102, 126, 234, 0.35)"
                      : "0 2px 6px rgba(0, 0, 0, 0.1)",
                    transform: isSelected ? "translateY(-2px) scale(1.02)" : "translateY(0) scale(1)",
                    minWidth: "120px",
                    whiteSpace: "nowrap",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.25)";
                      e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
                      e.currentTarget.style.borderColor = COLORS.primary_color_shade5;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.borderColor = COLORS.grey3;
                    }
                  }}
                >
                  <i 
                    className="fa fa-check-circle" 
                    style={{ 
                      marginRight: "6px",
                      fontSize: "12px",
                      opacity: isSelected ? 1 : 0
                    }} 
                  />
                  {item.exam_name}
                </button>
              );
            })}
          </div>
        </div>

        {/* Class & Subject Section */}
        <div style={classSubjectCardStyle}>
          {/* Class Selection */}
          <div style={{ marginBottom: "16px" }}>
            <h6 style={{ 
              margin: "0 0 8px 0", 
              fontSize: "12px", 
              fontWeight: "700", 
              color: COLORS.primary_color_shade7,
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <i className="fa fa-users" style={{ fontSize: "13px", color: COLORS.primary_color_shade5 }} />
              Participating Class
            </h6>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {mClassList && mClassList.map((item, index) => {
                const isSelected = selectedClassIndex === index;
                const classLabel = item.section_id === "No"
                  ? item.class_name
                  : `${item.class_name}:${item.section_name}`;
                
                return (
                  <button
                    key={`class-${item.class_id}-${index}`}
                    onClick={() => selectClass(index)}
                    style={getButtonStyle(isSelected)}
                    onMouseEnter={(e) => handleButtonMouseEnter(e, isSelected)}
                    onMouseLeave={(e) => handleButtonMouseLeave(e, isSelected)}
                  >
                    {classLabel}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Subject Selection */}
          <div>
            <h6 style={{ 
              margin: "0 0 8px 0", 
              fontSize: "12px", 
              fontWeight: "700", 
              color: COLORS.primary_color_shade7,
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <i className="fa fa-book" style={{ fontSize: "13px", color: COLORS.primary_color_shade5 }} />
              Participating Subject
            </h6>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {mSubject && mSubject.map((item2, index2) => {
                const isSelected = SUJECT_SELECTED_POSITION === index2;
                return (
                  <button
                    key={`subject-${item2.subject_id}-${index2}`}
                    onClick={() => getSubject(index2)}
                    style={getButtonStyle(isSelected)}
                    onMouseEnter={(e) => handleButtonMouseEnter(e, isSelected)}
                    onMouseLeave={(e) => handleButtonMouseLeave(e, isSelected)}
                  >
                    {item2.subject_name}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Preview Section */}
        <div style={previewCardStyle}>
          <h6 style={{ 
            margin: "0 0 10px 0", 
            fontSize: "13px", 
            fontWeight: "700", 
            color: COLORS.primary_color_shade7,
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}>
            <i className="fa fa-eye" style={{ fontSize: "14px", color: COLORS.primary_color_shade5 }} />
            Preview
          </h6>
          <div
            style={{
              borderRadius: "6px",
              overflow: "hidden",
              border: `1px solid ${COLORS.grey3}`,
              minHeight: "500px",
              position: "relative",
            }}
          >
            {!FILE_URL ? (
              <div style={emptyStateStyle}>
                <i className="fa fa-file-text" style={{ fontSize: "32px", color: COLORS.grey3 }} />
                <div style={{
                  fontSize: "13px",
                  color: COLORS.grey3,
                  fontWeight: "500",
                }}>
                  Select a subject to preview
                </div>
              </div>
            ) : showPreview ? (
              <div style={emptyStateStyle}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  border: `4px solid ${COLORS.grey3}`,
                  borderTop: `4px solid ${COLORS.primary_color_shade5}`,
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}></div>
                <div style={{
                  fontSize: "13px",
                  color: COLORS.primary_color_shade7,
                  fontWeight: "500",
                }}>
                  Loading preview...
                </div>
                <style>{`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}</style>
              </div>
            ) : (
              <Iframe
                ref={iframeRef}
                key={FILE_URL}
                url={FILE_URL}
                width="100%"
                height={iFrameHeight}
                overflow="auto"
                id="iFrame1"
                display="initial"
                position="relative"
                scrolling="no"
                style={{
                  border: "none",
                  borderRadius: "6px",
                }}
                onLoad={handleIframeLoad}
                onError={handleIframeError}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarkEntryCheckList;
